import React from "react";
import "./Crane_work_nationwide.css";

export default function Crane_work_nationwide() {
  return (
    <div className="Crane_work_nationwide-page">

      {/* =====================================================
          HERO - כותרת עליונה
      ===================================================== */}

      <section className="Crane_work_nationwide-hero">

        <div className="Crane_work_nationwide-overlay">
          <h1>עבודות מנוף בפריסה ארצית</h1>
        </div>

      </section>


      {/* =====================================================
          ARTICLE
      ===================================================== */}

      <section className="article-page">

        <div className="article-container">
          {/* =====================================================
              VIDEO
          ===================================================== */}

          <div className="article-video-box">

            <div className="article-video-header">

              <span className="video-line"></span>

              <span className="article-video-title">
                עבודות מנוף בפריסה ארצית
              </span>

              <span className="video-line"></span>

            </div>

            <div className="article-video-wrapper">

              <video
                className="article-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                preload="metadata"
                playsInline
                poster="/images/crane-work.jpg"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/3.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>


          </div>

          <h2>
            עבודות מנוף בפריסה ארצית – שירותי הרמה והובלה מקצועיים
          </h2>

          <p className="intro">
            נצר הובלות ומנופים בע"מ מספקת שירותי מנוף, הרמה
            והובלה בפריסה ארצית. אנו מעניקים פתרונות מקצועיים
            למגוון רחב של עבודות, החל מהרמת ציוד ומבנים ועד
            להובלת ציוד כבד, מכולות, קרוואנים, ממ"דים ומיגוניות.
          </p>

          <p>
            כאשר נדרשת עבודת מנוף, חשוב לבחור חברה בעלת ניסיון,
            ציוד מתאים וצוות מקצועי שיודע לבצע את העבודה בצורה
            בטוחה, יעילה ומדויקת.
          </p>

          <p>
            אנו מתאימים את סוג המנוף והמשאית לסוג העבודה,
            למשקל המטען, לגובה ההרמה ולתנאי השטח, במטרה לספק
            פתרון יעיל ומקצועי לכל פרויקט.
          </p>





          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <div className="section-title">
            <span className="square"></span>
            אילו עבודות מנוף אנו מבצעים?
          </div>

          <p>
            עבודות מנוף כוללות מגוון רחב של שירותים המיועדים
            ללקוחות פרטיים, עסקים, קבלנים, חברות בנייה ובעלי
            מקצוע.
          </p>

          <p>
            בין השירותים שאנו מספקים ניתן למצוא הרמת מבנים,
            העברת מבנים, הובלת ציוד כבד, הובלת מכונות,
            הרמת חומרי בניין, הובלת מכולות, קרוואנים,
            ממ"דים ומיגוניות ועוד.
          </p>


          {/* =====================================================
              SECTION 2
          ===================================================== */}

          <div className="section-title">
            <span className="square"></span>
            מנוף להרמת ציוד כבד ומבנים
          </div>

          <p>
            אחת העבודות המרכזיות בתחום היא הרמה והעברה של ציוד
            כבד ומבנים. במקרים שבהם לא ניתן לבצע את העבודה
            באופן ידני או באמצעות ציוד רגיל, מנוף מאפשר לבצע
            את ההרמה בצורה יעילה ומבוקרת.
          </p>

          <p>
            אנו מספקים שירותי מנוף להרמת מבנים, מכונות,
            ציוד תעשייתי, חומרי בניין ופריטים כבדים נוספים.
            לפני ביצוע העבודה נבחנים תנאי השטח, נקודת ההרמה,
            משקל המטען והגישה למקום.
          </p>


          {/* =====================================================
              SECTION 3
          ===================================================== */}

          <div className="section-title">
            <span className="square"></span>
            עבודות מנוף במקומות עם גישה מורכבת
          </div>

          <p>
            לא בכל אתר קיימת גישה נוחה למשאית או למנוף.
            לעיתים מדובר ברחוב צר, חצר פנימית, אתר בנייה
            צפוף או אזור שבו קיימות מגבלות מקום.
          </p>

          <p>
            במקרים כאלה יש צורך בתכנון נכון ובבחירת ציוד
            שמתאים לתנאי השטח. אנו בוחנים את תנאי הגישה
            ומספקים פתרון הרמה והובלה המותאם למקום ולמשימה.
          </p>


          {/* =====================================================
              SECTION 4
          ===================================================== */}

          <div className="section-title">
            <span className="square"></span>
            הובלה והרמה עם מנוף בפריסה ארצית
          </div>

          <p>
            השירות שלנו ניתן בפריסה ארצית ומאפשר להזמין שירותי
            מנוף והובלה למגוון רחב של אזורים ברחבי ישראל.
          </p>

          <p>
            בין אם מדובר בעבודה בתל אביב, ירושלים, באזור המרכז,
            השרון, הצפון או הדרום – אנו מספקים פתרונות הרמה
            והובלה בהתאם לצורכי הפרויקט ולתנאי השטח.
          </p>

          <p>
            השילוב בין הובלה להרמה מאפשר לבצע את העבודה בצורה
            יעילה יותר, במיוחד כאשר יש צורך להוביל את הציוד
            ולהציב אותו בדיוק בנקודה הרצויה.
          </p>


          {/* =====================================================
              SECTION 5
          ===================================================== */}

          <div className="section-title">
            <span className="square"></span>
            מנוף סל ומנוף זרוע להשכרה
          </div>

          <p>
            בנוסף לשירותי הובלה והרמה, ניתן לקבל שירותי מנוף
            המתאימים לעבודות בגובה ולמגוון משימות מקצועיות.
          </p>

          <p>
            אנו מספקים פתרונות הכוללים מנוף סל, מנוף זרוע
            ושירותי הרמה בהתאם לסוג העבודה ולדרישות בשטח.
            ניתן לקבל פתרון המתאים לעבודות בנייה, תחזוקה,
            התקנות, הרמות והעברת ציוד.
          </p>


          {/* =====================================================
              SECTION 6
          ===================================================== */}

          <div className="section-title">
            <span className="square"></span>
            הובלת ציוד כבד ומכונות
          </div>

          <p>
            הובלת מכונות וציוד כבד דורשת ציוד מתאים ותכנון
            מוקדם. אנו מבצעים הובלות של ציוד כבד ומכונות
            תוך התאמת פתרון ההובלה וההרמה לציוד ולתנאי המקום.
          </p>

          <p>
            השירות מתאים בין היתר למפעלים, אתרי בנייה,
            עסקים, מחסנים, בתי מלאכה ולקוחות פרטיים הזקוקים
            להעברת ציוד כבד ממקום למקום.
          </p>


          {/* =====================================================
              SECTION 7
          ===================================================== */}

          <div className="section-title">
            <span className="square"></span>
            הובלת מכולות, קרוואנים ומבנים
          </div>

          <p>
            אנו מבצעים גם הובלות והרמות של מכולות, קרוואנים,
            מבנים וממ"דים. עבודות מסוג זה דורשות תכנון נכון
            של ההובלה, ההרמה והצבת הפריט במקום היעד.
          </p>

          <p>
            אנו מתאימים את אמצעי ההובלה וההרמה בהתאם לגודל,
            למשקל ולתנאי הגישה אל המקום.
          </p>


          {/* =====================================================
              SECTION 8
          ===================================================== */}

          <div className="section-title">
            <span className="square"></span>
            למה חשוב לבחור חברת מנופים מקצועית?
          </div>

          <p>
            עבודת מנוף דורשת אחריות, ניסיון, תכנון נכון
            והתאמת ציוד למשימה. בחירה בציוד שאינו מתאים
            למשקל או לתנאי השטח עלולה להקשות על ביצוע העבודה.
          </p>

          <p>
            לכן חשוב לעבוד עם חברה שמכירה את התחום, יודעת
            להתאים את הציוד למשימה ומקפידה על ביצוע העבודה
            בצורה מסודרת ומקצועית.
          </p>


          {/* =====================================================
              SECTION 9
          ===================================================== */}

          <div className="section-title">
            <span className="square"></span>
            נצר הובלות ומנופים – כאן בשבילכם
          </div>

          <p>
            נצר הובלות ומנופים בע"מ מספקת שירותי הובלה,
            הרמה ומנוף למגוון רחב של צרכים. אנו מעניקים
            שירות מקצועי ומתאימים את פתרון ההרמה וההובלה
            לסוג העבודה, לציוד ולתנאי השטח.
          </p>

          <p>
            צריכים עבודת מנוף, הרמה או הובלה עם מנוף?
            צרו איתנו קשר ונשמח להבין את הצורך שלכם ולהציע
            פתרון מתאים.
          </p>


          {/* =====================================================
              CTA
          ===================================================== */}

          <div className="article-cta">

            <h2>
              צריכים מנוף או שירותי הובלה?
            </h2>

            <p>
              צרו קשר עם נצר הובלות ומנופים וקבלו פתרון
              מקצועי המותאם לעבודה שלכם.
            </p>

            <a
              href="tel:0500000000"
              className="cta-button"
            >
              התקשרו עכשיו
            </a>

          </div>

        </div>

      </section>

    </div>
  );
}